let ApexCharts = require('apexcharts')
import {formatBytes} from "../util/format-bytes";

$(function () {
    $('[data-chart-load]').each(function () {
        let self = $(this);
        let url = self.data('chart-load');
        let noData = self.data('chart-no-data');
        
        // Check if dark mode is enabled
        let isDarkMode = $('body').hasClass('dark-mode');
        
        let chartOptions = {
            chart: {
                group: "charts",
                height: self.data('chart-height') ?? 350,
                type: 'line',
                background: isDarkMode ? '#2b2b2b' : '#ffffff',
                foreColor: isDarkMode ? '#d4d4d4' : '#373d3f',
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true
                    }
                }
            },
            theme: {
                mode: isDarkMode ? 'dark' : 'light'
            },
            dataLabels: {
                enabled: false
            },
            series: [],
            title: {
                text: self.data('chart-title'),
                style: {
                    color: isDarkMode ? '#d4d4d4' : '#263238'
                }
            },
            noData: {
                text: self.data('chart-loading'),
                style: {
                    color: isDarkMode ? '#d4d4d4' : '#999999'
                }
            },
            xaxis: {
                type: "datetime",
                labels: {
                    style: {
                        colors: isDarkMode ? '#a0a0a0' : '#666666'
                    }
                },
                axisBorder: {
                    color: isDarkMode ? '#323232' : '#e0e0e0'
                },
                axisTicks: {
                    color: isDarkMode ? '#323232' : '#e0e0e0'
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: isDarkMode ? '#a0a0a0' : '#666666'
                    }
                }
            },
            grid: {
                borderColor: isDarkMode ? '#323232' : '#e0e0e0',
                strokeDashArray: 3
            },
            tooltip: {
                shared: true,
                theme: isDarkMode ? 'dark' : 'light',
                x: {
                    format: self.data('chart-time-format') ? self.data('chart-time-format') : "dd. MMM yy"
                }
            },
            stroke: {
                curve: 'smooth'
            },
            legend: {
                labels: {
                    colors: isDarkMode ? '#d4d4d4' : '#263238'
                }
            }
        };
        var yaxisType = self.data('chart-y-axis')
        if (yaxisType === 'bytes') {
            chartOptions.yaxis.labels.formatter = function (val, index) {
                return formatBytes(val);
            }
        }
        var chart = new ApexCharts(self[0], chartOptions);
        chart.render();
        $.getJSON(url, function (res) {
            if (!Array.isArray(res) || res.length === 0) {
                chart.updateOptions({
                    noData: {
                        text: noData
                    }
                }, true, true, true)
            } else {
                chart.updateSeries(res)
            }
        }).fail(function () {

        });
    });
})
